import type { AdOffer } from '@/lib/ads-campaigns';

interface OfferCardProps {
  offer: AdOffer;
  onSubscribe: (offer: AdOffer) => void;
}

function OfferCard({ offer, onSubscribe }: OfferCardProps) {
  return (
    <article
      className={`relative flex flex-col rounded-2xl p-6 md:p-7 transition-all duration-300 ${
        offer.recommended
          ? 'bg-gradient-to-b from-primary-500/15 to-accent-500/5 border border-accent-400/50 ring-1 ring-accent-400/20'
          : 'bg-background-100 border border-background-200/70 hover:border-primary-400/30'
      }`}
    >
      {offer.recommended && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold whitespace-nowrap">
          <i className="ri-star-fill" />
          Offre recommandée
        </span>
      )}

      <div className="flex items-center gap-3 mb-4">
        <div
          className={`w-12 h-12 flex items-center justify-center rounded-xl shrink-0 ${
            offer.recommended ? 'bg-accent-500/15 text-accent-400' : 'bg-primary-500/10 text-primary-400'
          }`}
        >
          <i className={`${offer.icon} text-2xl`} />
        </div>
        <div>
          <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-50">
            {offer.name}
          </h3>
          <p className="text-xs text-foreground-400">{offer.tagline}</p>
        </div>
      </div>

      <div className="mb-5">
        <span className="font-heading font-bold text-3xl md:text-4xl text-foreground-50">
          {offer.price.toLocaleString('fr-FR')}
        </span>
        <span className="text-sm text-foreground-400"> FCFA</span>
        <span className="block text-xs text-foreground-500 mt-0.5">par mois</span>
      </div>

      <ul className="space-y-2.5 mb-6 flex-1">
        {offer.features.map((feature) => (
          <li key={feature} className="flex items-start gap-2.5">
            <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500/15 shrink-0 mt-0.5">
              <i className="ri-check-line text-accent-400 text-sm" />
            </div>
            <span className="text-sm text-foreground-200 leading-relaxed">{feature}</span>
          </li>
        ))}
      </ul>

      <button
        type="button"
        onClick={() => onSubscribe(offer)}
        className={`w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg font-semibold text-sm whitespace-nowrap transition-colors ${
          offer.recommended
            ? 'bg-accent-500 text-foreground-950 hover:bg-accent-400'
            : 'bg-primary-500 text-foreground-950 hover:bg-primary-400'
        }`}
      >
        Souscrire à cette offre
        <i className="ri-arrow-right-line" />
      </button>
    </article>
  );
}

export default OfferCard;